import React, { Component } from "react"
import styled from 'styled-components'
import get from 'lodash/get'
import { Button } from 'reactstrap'
import { FONTS } from '../../../../constants'

export default class Searchbar extends Component {
  render() {
    const editHardware = get(this.props, 'editHardware')
    const projectByID = get(this.props, 'projectByID')
    const presale_snapshot = get(projectByID, 'presale_snapshot.snapshot')
    const rSelected = get(this.props, 'rSelected')
    const isPresale = presale_snapshot && rSelected === 1
    const canEdit = get(projectByID, '$can_edit')
    const fallbackNanOrInfinity = (number) => {
      return number === 'NaN' || number === Infinity ? '0.00' : number
    }
    const total_hardwares_cost = isPresale ? get(presale_snapshot, '$total_hardwares_cost', '-') : get(projectByID, '$total_hardwares_cost', '-')
    const total_hardwares_price = isPresale ? get(presale_snapshot, '$total_hardwares_price', '-') : get(projectByID, '$total_hardwares_price', '-')
    const total_hardwares_margin = isPresale ? fallbackNanOrInfinity(get(presale_snapshot, '$total_hardwares_margin', '-')) : fallbackNanOrInfinity(get(projectByID, '$total_hardwares_margin', '-'))

    const clickEdit = get(this.props, 'clickEdit')
    const confirmEditHardware = get(this.props, 'confirmEditHardware')
    const cancelEdit = get(this.props, 'cancelEdit')
    const clickAddHardware = get(this.props, 'clickAddHardware')

    return (
      <SearchDivStyle >
        <Header>
          <TextHeader>Total Cost (฿)</TextHeader>
          <TextNumber>{ total_hardwares_cost }</TextNumber>
          <TextHeader>Total Price (฿)</TextHeader>
          <TextNumber>{ total_hardwares_price }</TextNumber>
          <TextHeader>Margin (%)</TextHeader>
          <TextNumber>{ total_hardwares_margin } %</TextNumber>
        </Header>
        <SearchDiv>
          {/* <SearchField
            onChange={ this.props.handleSearch }
            onKeyDown={ this.props.handleSearch }
            placeholder={ 'Search By Hardware Name, Code, Type' }
          /> */}
          { !isPresale &&
            <ButtonGroup>
              { !editHardware && canEdit &&
                <CustomButton color='success' onClick={ () => clickEdit() }>Edit</CustomButton>
              }
              { editHardware &&
                <CustomButton color='success' onClick={ () => confirmEditHardware() }>Save</CustomButton>
              }
              { editHardware &&
                <CustomButton onClick={ () => cancelEdit() }>Cancel</CustomButton>
              }
              { editHardware &&
                <CustomButton color='danger' onClick={ () => clickAddHardware() }>Add Hardware Cost</CustomButton>
              }
            </ButtonGroup>
          }
        </SearchDiv>
      </SearchDivStyle>

    )
  }
}
const SearchDivStyle = styled.div`
  background-color: #ffffff ;
  margin-top: 10px;
`
const ButtonGroup = styled.div`
  text-align: right;
  margin: auto;
  margin-right: 0px !important;
  width: 50%;
`
const Header = styled.div`
  height: 60px;
  background: #404040;
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`
// const SearchField = styled.input`
//   background: url(${SearchIcon}) no-repeat scroll 10px 10px;
//   background-size: 20px 20px;
//   padding-left:40px;
//   font-family: 'Gotham' !important;
//   font-size: 15px;
//   width: 20%;
//   height: 40px;
//   border: 1px solid #ccc;
//   border-radius: 4px;
//   margin: auto;
//   margin-left: 2% !important;
//   box-sizing: border-box;
//   -o-text-overflow: ellipsis;
//   -ms-text-overflow: ellipsis;
//   text-overflow: ellipsis;
//   ::placeholder {
//     color: #CCCCCC;
//   }
// `
const TextHeader = styled.p`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin:auto;
  margin-right: 20px !important;
`
const TextNumber = styled.p`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin:auto;
  margin-left: 0% !important;
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  margin-left: 5px;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
  }
`
const SearchDiv = styled.div`
  height: 60px;
  padding: auto;
  display: flex;
  flex-direction: row;
`



// WEBPACK FOOTER //
// ./src/components/project-information/searchbar/searchbar-hardware/index.js